
export const ProductCategories = {
	traits: ['powerSaving', 'securityAndHealth', 'design'],
	categories: ['standard', 'premium', 'exclusive']
}
